export const steps = [
  {
    target: '#avatar_el',  // We're using document.querySelector() under the hood
    content: `Select a featured image for your collection. <br/> Dimensions: 500x500 <br/> Format: jpg, png or gif`,
    params: {
      enableScrolling: false
    }
  },
  {
    target: '#hero_el2',  // We're using document.querySelector() under the hood
    content: `Select a background image for your collection. <br/> Dimensions: 1920x1080 <br/> Format: jpg or png`,
    params: {
      enableScrolling: false
    }
  },
  {
    target: '.tokens_count_el',  // We're using document.querySelector() under the hood
    content: `How many total tokens are you selling in your drop? Click here and input that number now.`,
    params: {
      placement: 'top',
      enableScrolling: false
    }
  },
  {
    target: '.token_price_el',  // We're using document.querySelector() under the hood
    content: `How much XTZ do you want per token? Click here and input that number now.`,
    params: {
      placement: 'top',
      enableScrolling: false
    }
  },
  {
    target: '#start_at_el',  // We're using document.querySelector() under the hood
    content: `When do you want your crowdsale to begin? Click to set date and time in your own timezone.`,
    params: {
      placement: 'top',
      enableScrolling: false
    }
  },
  {
    target: '#profile_el',  // We're using document.querySelector() under the hood
    content: `This will display information about you as the creator. To update this information, please visit your`,
    params: {
      enableScrolling: true
    }
  },
  {
    target: '.name_el',
    content: 'Click here to edit your collection’s name.',
    params: {
      // placement: 'right',
      enableScrolling: false
    }
  },
  {
    target: '#description_btn_el',
    content: 'Click here to write a rich text description of your collection. Up to 500 characters are allowed.',
    params: {
      // placement: 'right',
      enableScrolling: false
    }
  },
  {
    target: '#select_art_el',
    content: 'Click to select your artwork folder and generate some sample tokens.',
    params: {
      placement: 'top',
      enableScrolling: false
    }
  },
  {
    target: '#sample_art_el',
    content: 'These 9 samples will be displayed to give users a feel for your collection. You can change them out using the edit button on each.',
    params: {
      placement: 'top',
      enableScrolling: false
    }
  },
  {
    target: '#upload_art_el',
    content: 'When you are satisfied everything looks good, you can upload your files to ArtForge and continue.',
    params: {
      placement: 'top',
      enableScrolling: true
    }
  },
  {
    target: '#sociale_el',
    content: 'If you have some social links, click on each icon to fill them in. Please use full urls i.e. “https://twitter.com/yourhandle”',
    params: {
      placement: 'bottom',
      enableScrolling: true
    }
  },
  {
    target: '#token_name_el',
    content: 'Set the label for each of your tokens. They will be numbered TOKEN #1, TOKEN #2 where TOKEN is your input name.',
    params: {
      // placement: 'left',
      enableScrolling: false
    }
  },
  {
    target: '#token_symbol_el',
    content: 'This symbol is displayed in user wallets. Max 5 chars. All caps.',
    params: {
      // placement: 'left'
    }
  },
  {
    target: '#tokens_per_wallet_el',
    content: 'Limit how many tokens each wallet can mint. Set to 0 for no limit.',
    params: {
      // placement: 'left'
    }
  },
  {
    target: '#reserve_amount_el',
    content: 'Reserve some of your crowdsale tokens so that only your wallet can mint them, at no cost. Useful for giveaways, etc.',
    params: {
      // placement: 'left'
    }
  },
  {
    target: '#placeholder_el',
    content: 'Set the placeholder art that users will see when they initially mint. This gets replaced with real art after the reveal delay.',
    params: {
      // placement: 'left'
    }
  },
  {
    target: '#reveal_delay_el',
    content: 'How many hours should we wait after a token is minted to generate the artwork and replace the placeholder.',
    params: {
      // placement: 'left'
    }
  },
  {
    target: '#add_collab_el',
    content: "If you're working with others, click here to add them as collaborators. Must sum to 100%.",
    params: {
      placement: 'left'
    }
  },
  {
    target: '#royalty_el',
    content: 'What % royalty do you want to set for secondary sales - This is your cut when collectors resale tokens from your collection.',
    params: {
      // placement: 'left'
    }
  },
  {
    target: '#royalty_collabs_el',
    content: "If you're sharing royalties with others, click here to add their wallets. Must sum to 100%.",
    params: {
      placement: 'left'
    }
  },
  {
    target: '#publishButton',
    content: 'When you are ready, click here to publish your collection and schedule your crowdsale! Publishing is final, so make sure you are happy with your artwork and settings first.'
  }
]

export const stepsSandbox = [
  {
    target: '#first_el',  // We're using document.querySelector() under the hood
    content: `Welcome.`,
    params: {
      enableScrolling: false
    }
  },
]
